import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, SaveButton, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDataFusionControl extends Layout {
    buttonOpenClassic: Button;
    headerSpacer1: HorizontalSpacer;
    labelDataFusionSupport: Label;
    labelHeader: Label;
    labelLogs: Label;
    lableProcessSettings: Label;
    panel1: Panel;
    savebuttonMain: SaveButton;
    sourceEdiControl: DataSource;
    sourceEdiControlShared: DataSource;
    sourceEdiLoggerSetting: DataSource;
    sourceEdiProcessSetting: DataSource;
    switchIntercompanyEnabled: Switch;
    switchUseTemplateCache: Switch;
    switchUsersDispatchTZ: Switch;
    tabAuditor: Tab;
    tabDatesTimes: Tab;
    tabIntercompany: Tab;
    tabLogs: Tab;
    tabMappingTemplates: Tab;
    tabMonitorRecovery: Tab;
    tabNotifications: Tab;
    tabProcesses: Tab;
    tableLogs: Table;
    tableProcesses: Table;
    tabsetDataFusionControl: Tabset;
    textboxAppSrvrTimezone: Textbox;
    textboxAutoinRecoverCp: Textbox;
    textboxCommoutRecoverCp: Textbox;
    textboxMapperLoopMax: Textbox;
    textboxMonitorProcessCp: Textbox;
    textboxSanHost: Textbox;
    textboxSanMinInterval: Textbox;
    textboxSanPort: Textbox;
    textboxStatusInterval: Textbox;
    textboxTemplateCacheMax: Textbox;
}
